import React from 'react';
import { Button } from '../../../components/base/Button';

const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: "1",
      title: "Get Free Satellite Quote",
      description: "Provide your gutter details or your address for accurate satellite measurement. Receive same-day pricing for your specific needs.",
      image: "https://public.readdy.ai/ai/img_res/c826e607a47bf58d7f2377be13f72e5f.jpg"
    },
    {
      number: "2", 
      title: "Chat With A GutterBrush Guy!",
      description: "Talk with Randy or Alex, our friendly gutter experts. Get personalized recommendations and sizing for your specific gutter system.",
      image: "https://readdy.ai/api/search-image?query=Friendly%20professional%20man%20talking%20on%20phone%20with%20warm%20smile%2C%20customer%20service%20representative%20having%20pleasant%20conversation%2C%20approachable%20business%20expert%20on%20phone%20call%2C%20professional%20consultation%20over%20phone%20with%20friendly%20demeanor&width=400&height=300&seq=process-002b&orientation=landscape"
    },
    {
      number: "3",
      title: "Easy Installation",
      description: "Receive your GutterBrush system and install it yourself in no time. No special tools required - just place in gutters and you're done!",
      image: "https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/842663892849d36b040a6114514bc9de.jpeg"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Easy Steps to Gutter Protection
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From quote to installation, we make protecting your home simple and affordable. 
            Most customers are protected within days.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-8">
                <img 
                  src={step.image}
                  alt={step.title}
                  className="w-full h-64 object-cover rounded-lg shadow-lg"
                />
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
                  {step.number}
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-white rounded-lg p-8 shadow-lg max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              Ready to Get Started?
            </h3>
            <p className="text-gray-600 mb-6">
              Most homes can be completely protected for $300-$400. 
              Get your free quote today and join thousands of satisfied customers.
            </p>
            <Button size="lg" className="mr-4" href="https://www.gutterbrush.com/pages/request-a-free-gutterbrush-quote" target="_blank" rel="noopener noreferrer">
              Get Free Quote Now
            </Button>
            <Button variant="outline" size="lg">
              Call Randy or Alex
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
